module.exports = __webpack_public_path__ + "img/456A73_779B9E_173A46_154C5D-256px.3e9f6839.png";